import React, { useRef, useState, useEffect, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function NewsBreadcrumbs({ TheTitle }) {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { CategoryName } = useParams();

  const location = useLocation();
  const history = useHistory();

  const { CategoryTitle } = location.state || {}; // Access the passed state

  const CheckBreadcrumbs = [
    1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000,
  ];

  const handleDivClick = () => {
    history.push({
      pathname: `/actions`,
    });
  };
  return (
    <div>
      {CheckBreadcrumbs.includes(Number(CategoryName)) ? (
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            <a style={{ fontSize: MyWidth <= 1024 ? 13 : 16 }}>LEMAQ</a>
          </Link>
          <Typography sx={{ color: "text.primary" }}>
            <a style={{ fontSize: MyWidth <= 1024 ? 13 : 16 }}>
              {CategoryTitle}
            </a>
          </Typography>
        </Breadcrumbs>
      ) : (
        <>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              <a style={{ fontSize: MyWidth <= 1024 ? 13 : 16 }}>LEMAQ</a>
            </Link>
            <Link
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDivClick();
              }}
              underline="hover"
              color="inherit"
              //href={`/allcategories/${CodeCat}`}
            >
              <a style={{ fontSize: MyWidth <= 1024 ? 13 : 16 }}>
                {t("profile.Specialoffers")}
              </a>
            </Link>
            <Typography sx={{ color: "text.primary" }}>
              <a style={{ fontSize: MyWidth <= 1024 ? 13 : 16 }}>{TheTitle}</a>
              {/* {CategoryTitle} */}
            </Typography>
          </Breadcrumbs>
        </>
      )}
    </div>
  );
}
